module.exports = __webpack_public_path__ + "static/media/person-img.6e513bcf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person-img.svg
// module id = 740
// module chunks = 0